import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import AuthCard from "../../components/auth/AuthCard";
import { usePageTitle } from "../../utils/usePageTitle";

export const YandexNoEmailPage = () => {
  const { t } = useTranslation();
  usePageTitle(t("yandexNoEmail.title"));

  return (
    <AuthCard>
      <h1>{t("yandexNoEmail.title")}</h1>
      <p>
        <Trans
          i18nKey="yandexNoEmail.description"
          components={{ signupLink: <Link to="/signup/0" /> }}
        />
      </p>
    </AuthCard>
  );
};
